import React from 'react';
import { integrations } from './saasContent';

const SaasIntegrationsSection = () => {
  return (
    <section id="integrations" className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-12">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-6">
            Integrations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-[2.125rem] font-semibold text-black tracking-tight leading-snug mb-4">
            Plugs into the stack you already use
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            Connect paid channels, messaging, CRM, and custom APIs—read-only and secure.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 max-w-3xl mx-auto">
          {integrations.map((name) => (
            <span
              key={name}
              className="rounded-full border border-stone-200 bg-white px-4 py-2 text-sm sm:text-base font-medium text-stone-700 shadow-sm"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SaasIntegrationsSection;
